import { Timer } from '../utils/process.js';
import { on, _global } from '../utils/unils.js';
import { _techReportPb } from './new-report.js';
import { options } from './option.js';

let timer = null;
let RESOURCE_REPORT_INTERVAL = 1000 * 60 * 3; // 默认上报时间3分钟
let observer = null;
const reportResourcePoolKey = 'BILI_MIRROR_RESOURCE_TIME'; // 存localKey
// 暂时只支持监控数据的类型 详见返回类型:
// https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/initiatorType#xmlhttprequest
const TYPE_BASE = ['xmlhttprequest', 'fetch', 'img', 'image', 'link', 'css', 'video', 'iframe', 'script'];
// 对应映射表
const TYPE_MAPPING = {
    API: 'xmlhttprequest,fetch',
    IMG: 'img,image',
    CSS: 'link,css',
    JS: 'script',
    VIDEO: 'video',
    IFRAME: 'iframe'
};
/**
 * 获取网页资源情况
 */
class WebResourceTime {
    constructor() {
        /**
         * 清除上报和定时器副作用
         */
        this._cleanUpReportPool = () => {
            // beforeunload事件需要上报时，需手动调用pbreport的flush方法触发一次上报
            timer === null || timer === void 0 ? void 0 : timer.clear();
            window.__biliMirrorPbInstance__ && window.__biliMirrorPbInstance__.flush && window.__biliMirrorPbInstance__.flush();
        };
        this.config = options.config['resource-time'] || {};
        this.resourceWaitList = [];
        this.disablePush = false;
    }
    /**
     * 开始监控资源
     */
    on() {
        if (!PerformanceObserver || !(PerformanceObserver === null || PerformanceObserver === void 0 ? void 0 : PerformanceObserver.supportedEntryTypes))
            return;
        this._getAllData();
        this._createObserver();
    }
    /**
     * 销毁
     */
    destroy() {
        observer && observer.disconnect();
        timer === null || timer === void 0 ? void 0 : timer.clear();
    }
    /**
     * 获取所有的数据
     */
    _getAllData() {
        const resourceList = performance.getEntriesByType('resource');
        if (!resourceList && !resourceList.length)
            return;
        resourceList.forEach(item => {
            this.resourceWaitList.push(item);
        });
    }
    /**
     * 处理数据中的资源队列
     */
    _handlerResourceInit() {
        this.disablePush = true;
        while (this.resourceWaitList.length) {
            let firstOne = this.resourceWaitList.shift();
            // 根据kv配置开始选择符合条件的资源做整体的监控上报
            if (!this._isCheckResource(firstOne))
                continue;
            // 计算数值
            const computeData = this._computeResourceData_(firstOne);
            // 推送本地存储
            this._addResourceReportPool(computeData);
        }
        this.disablePush = false;
        this._startReportInterval();
    }
    /**
     * 通过配置看是否命中监控，过滤，采样
     * @param item
     * @returns
     */
    _isCheckResource(item) {
        // 过滤暂时不支持监控的资源型
        if (!TYPE_BASE.includes(item.initiatorType))
            return false;
        // 无配置直接过滤
        if (!Object.keys(this.config).length)
            return false;
        let res = false;
        for (let key in this.config) {
            const checkArr = TYPE_MAPPING[key].split(',');
            // 找到匹配资源类型
            if (checkArr.includes(item.initiatorType)) {
                // 匹配值为类型的所有
                if (this.config[key] === '*') {
                    res = true;
                    break;
                }
                // 没有key跳过循环
                if (!this.config[key])
                    continue;
                // 匹配值,如果是数组类型,看数组内容是否符合name
                if (Array.isArray(this.config[key]) && this.config[key].length) {
                    for (let i = 0; i < this.config[key].length; i++) {
                        const name = item.name.split('?')[0];
                        if (name.match(this.config[key][i])) {
                            res = true;
                            break;
                        }
                    }
                }
            }
        }
        return res;
    }
    /**
     * 计算资源的数值
     * 详细的额外信息，例如:ssl、dns、tcp、response、request有可能为0原因:
     * 1.资源添加 crossorgin="anonymous" 属性
     * 2.添加跨域HTTP响应头： Access-Control-Allow-Origin
     * 所以暂时不做统计
     */
    _computeResourceData_(firstOne) {
        const urlSplit = firstOne.name.split('?');
        const { transferSize, initiatorType, duration, nextHopProtocol, redirectStart, redirectEnd, domainLookupEnd, domainLookupStart, connectEnd, connectStart, secureConnectionStart, responseStart, requestStart, responseEnd } = firstOne;
        return {
            url: urlSplit[0],
            query: urlSplit[1],
            duration: duration.toFixed(2),
            size: transferSize,
            type: initiatorType,
            protocol: nextHopProtocol,
            redirectTime: redirectEnd - redirectStart,
            dnsTime: domainLookupEnd - domainLookupStart,
            sslTime: connectEnd - secureConnectionStart,
            tcpTime: connectEnd - connectStart,
            requestTime: responseStart - requestStart,
            responseTime: responseEnd - responseStart
        };
    }
    /**
     * 数据推入localStorage中暂存
     */
    _addResourceReportPool(parseData) {
        let resourcePool = JSON.parse(localStorage.getItem(reportResourcePoolKey) || '{}');
        const KEY = parseData.url;
        if (!resourcePool[KEY]) {
            resourcePool[KEY] = Object.assign({}, parseData);
        }
        localStorage.setItem(reportResourcePoolKey, JSON.stringify(resourcePool));
    }
    /**
     * 开启自动定时上报任务
     */
    _startReportInterval() {
        if (timer)
            return;
        timer = new Timer();
        timer.repeat(this._clearResourceReport, RESOURCE_REPORT_INTERVAL);
        // 页面关闭前，清一次reportPool
        on(_global, 'beforeunload', () => {
            this._clearResourceReport();
            this._cleanUpReportPool();
        });
    }
    /**
     * 上报&清空local的值
     */
    _clearResourceReport() {
        try {
            let resourcePool = JSON.parse(localStorage.getItem(reportResourcePoolKey) || '{}');
            if (Object.keys(resourcePool).length) {
                _techReportPb({
                    type: 'performance',
                    eventId: `${options.origin}.${options.module}.PERFORMANCE.RESOURCETIME`,
                    msg: {
                        resourceListInfo: Object.assign({}, resourcePool)
                    }
                });
            }
            localStorage.setItem(reportResourcePoolKey, '');
        }
        catch (error) { }
    }
    /**
     * 创建监听者
     */
    _createObserver() {
        observer = new PerformanceObserver(list => {
            list.getEntries().forEach(entry => {
                this.resourceWaitList.push(entry.toJSON());
            });
            if (this.disablePush)
                return;
            this._handlerResourceInit();
        });
        observer.observe({ entryTypes: ['resource'] });
    }
}

export { WebResourceTime };
